module.exports = __webpack_public_path__ + "media/images/recipes/eenpersoons_beenham-596afc28d79127b95f78f0a319425bb6.pdf";